var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',[_vm._v(" Это страница для входа в аккаунт "),_c('strong',[_vm._v("юзера")]),_vm._v(", которая будет в будущем. ")])])}]

export { render, staticRenderFns }